import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { InsightsIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { MomentumCardData } from '../../hooks/usePetitionMarquee';
import { CardWrapper } from '../CardWrapper';

type Props = Readonly<{
	petition: MomentumCardData;
	onClick: () => void;
	duplicate?: boolean;
}>;

export const MomentumCard: React.FC<Props> = ({ petition, onClick, duplicate = false }) => {
	const { translate } = useI18n();

	return (
		<CardWrapper
			cardKey={petition.key}
			href={petition.href}
			onClick={onClick}
			duplicate={duplicate}
			icon={InsightsIcon}
			label={translate('corgi.components.petition_card.momentum_badge.gaining_momentum')}
			trailingLabel={petition.relativeTimeLabel}
		>
			<div className="flex grow flex-col pt-2">
				<Text as="span" variant="body" size="x-large" fontWeight="bold" className="text-typography-strong">
					{petition.dailySignaturesLabel}
				</Text>
				<Text as="span" variant="body" size="x-small" className="text-typography-weak line-clamp-1">
					{petition.title}
				</Text>
			</div>
		</CardWrapper>
	);
};
